/**
 * ContractStatusBadge Component
 *
 * Sprint 006 (A2): shared StatusBadge + tone role-map. Deliberate change:
 * cancelled is a TERMINAL state → muted, not red (red = needs action).
 */
import { StatusBadge, type StatusTone } from '../ui';
import { statusLabels, type ContractStatus } from '../../hooks/useContracts';

export const CONTRACT_STATUS_TONES: Record<ContractStatus, StatusTone> = {
  draft: 'neutral',
  active: 'success',
  paused: 'warning',
  completed: 'info',
  cancelled: 'muted',
};

interface ContractStatusBadgeProps {
  status: ContractStatus;
  size?: 'sm' | 'md';
  className?: string;
}

export function ContractStatusBadge({ status, size = 'md', className = '' }: ContractStatusBadgeProps) {
  return (
    <StatusBadge tone={CONTRACT_STATUS_TONES[status]} size={size} className={className}>
      {statusLabels[status]}
    </StatusBadge>
  );
}
